import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getRoot } from 'lexical'
import { FC, useEffect } from 'react'

const AutoFocusPlugin: FC = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    // Focus the editor when the component mounts
    editor.focus()

    // Ensure the cursor is at the end of the content
    editor.update(() => {
      const root = $getRoot()
      const lastChild = root.getLastChild()
      if (lastChild) {
        lastChild.selectEnd()
      } else {
        root.selectEnd()
      }
    })
  }, [editor])

  return null
}

export default AutoFocusPlugin
